import Collection from '@models/Collection'
import ApiRoutes from '@utils/api-routes'
import http from '@utils/http'

export default class CollectionService {
  /**
   * Fetches a member's private collections
   */
  static async fetchPrivateCollections(): Promise<Collection[]> {
    const [resp] = await http.post<CollectionsResponse>(ApiRoutes.members.privateCollectionsPath())
    if (!resp) return []
    return resp.data.collections ?? []
  }

  /**
   * Creates a new collection using the given values
   */
  static async create(name: string, opts?: CreateCollectionOptions): Promise<Collection | null> {
    const data: Partial<Collection> = { name }
    if (opts) {
      data.description = opts.description
      data.public = opts.public
      if (opts.admin) {
        data.button_label = opts.admin.buttonLabel
        data.is_marketplace_collection = opts.admin.isMarketplaceCollection
        data.query = opts.admin.query
      }
    }
    const [resp] = await http.post<CollectionResponse>(ApiRoutes.collections.createPath(), data)
    if (!resp) return null
    return resp.data.collection
  }
}

export type UploadCollectionImageResponse = {
  collection_image_id: number
  success: boolean
}
export async function uploadCollectionImageData(
  data: string
): Promise<UploadCollectionImageResponse | null> {
  const [resp] = await http.post<UploadCollectionImageResponse>(
    ApiRoutes.clientUploadCollectionImageDataPath(),
    { data }
  )
  if (!resp) return null
  return resp.data
}

export type UpdateCollectionImageResponse = {
  collection: Collection
}
export async function updateCollectionImage(
  collectionId: number,
  collectionImageId: number,
  blurHash: string | null
): Promise<UpdateCollectionImageResponse | null> {
  const [resp] = await http.post<UpdateCollectionImageResponse>(
    ApiRoutes.collections.updateImagePath(),
    { collection_id: collectionId, collection_image_id: collectionImageId, blur_hash: blurHash }
  )
  if (!resp) return null
  return resp.data
}

// region Types
export type CreateCollectionOptions = {
  description?: string
  public?: boolean
  admin?: {
    isMarketplaceCollection?: boolean
    query?: string
    buttonLabel?: string
  }
}

type CollectionResponse<I = unknown> = {
  collection: Collection<I>
}

type CollectionsResponse<I = unknown> = {
  collections: Collection<I>[]
}
// endregion Types
